import React from 'react';
import Breadcrumb from '../components/Breadcrumb';
import ContactAreaOne from '../components/ContactAreaOne';
import CounterAreaOne from '../components/CounterAreaOne';
import FaqAreaOne from '../components/FaqAreaOne';
import FooterOne from '../components/FooterOne';
import NavBar from '../components/NavBar';
import TeamAreaOne from '../components/TeamAreaOne';
import WorkProcessOne from '../components/WorkProcessOne';
import ServiceAreaOne from '../components/ServiceAreaOne';
import AboutCompanyOne from '../components/AboutCompanyOne';

const AboutCompany = () => {
  return (
    <>
      {/* Navigation Bar */}
      <NavBar />

      {/* Navigation Bar */}
      <Breadcrumb title={'About Us'} />

      {/* About Area One */}
      <AboutCompanyOne />

     

      {/* FAQ Area One */}
      <FaqAreaOne />

      

      {/* Counter Area One  <CounterAreaOne />*/}
      

      {/* Contact Area One   <ContactAreaOne />*/}
    

     

      {/* Footer One */}
      <FooterOne />
    </>
  );
};

export default AboutCompany;
